import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dev-tools-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "dev-tools-page__title" }, [
  /*#__PURE__*/_createTextVNode(" Script File or JSON "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("sub", null, [
    /*#__PURE__*/_createElementVNode("small", null, "You can find the examples in project sources. Look for SampleDevSetup.js or SampleDevSetupConfig.json files as a start point.")
  ])
], -1)
const _hoisted_3 = { class: "dev-tools-page__section" }
const _hoisted_4 = { class: "dev-tools-page__form" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Load Script / JSON")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Clear")
const _hoisted_8 = { class: "dev-tools-page__section" }
const _hoisted_9 = { class: "dev-tools-page__info" }
const _hoisted_10 = { class: "dev-tools-page__title" }
const _hoisted_11 = { class: "dev-tools-page__section" }
const _hoisted_12 = { class: "dev-tools-page__controls" }
const _hoisted_13 = { class: "dev-tools-page__content" }
const _hoisted_14 = { class: "dev-tools-page__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NTextareaAutosize = _resolveComponent("NTextareaAutosize")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs?.file?.click()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _hoisted_6,
        (_ctx.scripts.length)
          ? (_openBlock(), _createBlock(_component_NButton, {
              key: 0,
              onClick: _ctx.clear,
              type: "secondary"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          ref: "file",
          type: "file",
          accept: ".js, .json",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fileHandler && _ctx.fileHandler(...args))),
          style: {"visibility":"hidden"}
        }, null, 544)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, "Installed " + _toDisplayString(_ctx.scripts.length) + " scripts", 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scripts, (script) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: script.name
      }, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(script.name), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_NButton, {
              icon: "play",
              round: "",
              onAction: ($event: any) => (script.runScript()),
              loading: script.loading
            }, null, 8, ["onAction", "loading"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_NTextareaAutosize, {
              modelValue: script.code,
              "onUpdate:modelValue": ($event: any) => ((script.code) = $event),
              minRows: 3,
              mono: true,
              spellcheck: false
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, _toDisplayString(script.status), 1),
        _createElementVNode("div", null, _toDisplayString(script.error), 1)
      ], 64))
    }), 128))
  ]))
}